"use strict";

exports.__esModule = true;
exports.FieldSet = FieldSet;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _excluded = ["icon", "legend", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var StyledFieldSet = _styledComponents["default"].fieldset.withConfig({
  displayName: "FieldSet__StyledFieldSet",
  componentId: "sc-vkr6hu-0"
})(["border-color:rgba(0,0,0,0.2);border-width:1px;padding:1rem;"]);
var StyledLegend = _styledComponents["default"].legend.withConfig({
  displayName: "FieldSet__StyledLegend",
  componentId: "sc-vkr6hu-1"
})(["font-size:1.1rem;"]);

/**
 * Displays a styled `<fieldset />`, with optional icon and legend.
 */
function FieldSet(_ref) {
  var icon = _ref.icon,
    legend = _ref.legend,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var legendParts = [];
  if (icon) {
    legendParts.push(/*#__PURE__*/_react["default"].createElement(_core.Icon, {
      size: 20,
      icon: icon,
      key: "icon"
    }));
    legendParts.push(" ");
  }
  if (legend) {
    legendParts.push(/*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "legend"
    }, legend));
  }
  return /*#__PURE__*/_react["default"].createElement(StyledFieldSet, extra, legendParts.length === 0 ? null : /*#__PURE__*/_react["default"].createElement(StyledLegend, null, legendParts), children);
}